<main class="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-gray-50 to-white">
  <!-- Verification Card -->
  <div class="w-full max-w-md bg-white dark:bg-slate-800 rounded-2xl shadow-md p-8 border border-gray-100">
    <!-- Header with Logo -->
    <div class="text-center mb-8">
      <!-- Logo-inspired Icon -->
      <div class="inline-flex items-center justify-center mb-5">
        <div class="relative">
          <div class="flex items-center gap-1.5 p-4 bg-gradient-to-br from-primary-50 to-primary-100 rounded-2xl">
            <div class="flex flex-col gap-1.5">
              <div class="w-4 h-4 rounded-full bg-primary-500 shadow-sm"></div>
              <div class="w-4 h-4 rounded-full bg-primary-500 shadow-sm"></div>
              <div class="w-4 h-4 rounded-full bg-primary-300"></div>
            </div>
            <div class="flex flex-col gap-1.5">
              <div class="w-4 h-4 rounded-full bg-secondary-500 shadow-sm"></div>
              <div class="w-4 h-4 rounded-full bg-secondary-500 shadow-sm"></div>
              <div class="w-4 h-4 rounded-full bg-secondary-500 shadow-sm"></div>
            </div>
            <div class="flex flex-col gap-1.5">
              <div class="w-4 h-4 rounded-full bg-secondary-500 shadow-sm"></div>
              <div class="w-4 h-4 rounded-full bg-primary-500 shadow-sm"></div>
              <div class="w-4 h-4 rounded-full bg-primary-300"></div>
            </div>
          </div>
        </div>
      </div>
      
      <h1 class="text-2xl font-semibold text-primary-600 mb-2">Phone Verification</h1>
      <p class="text-sm font-normal text-gray-500 dark:text-slate-400">Enter your phone number and verification code to continue</p>
    </div>

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
        <p class="text-sm font-normal text-red-600">{{ errorMessage }}</p>
      </div>
    }

    <!-- Form -->
    <form [formGroup]="verificationForm" (ngSubmit)="onSubmit()" class="space-y-5">
      <!-- Phone Number Field -->
      <div class="form-container">
        <app-custom-input
          [label]="'Phone Number'"
          [showLabel]="true"
          [showAsteric]="true"
          [placeholder]="'Enter 10-digit phone number'"
          formControlName="phoneNumber"
          type="tel"
          [maxlength]="10"
          (valueChange)="onPhoneNumberInput($event)"
        ></app-custom-input>
        @if (verificationForm.get('phoneNumber')?.invalid && verificationForm.get('phoneNumber')?.touched) {
          <p class="text-error text-xs mt-2 font-normal">
            @if (verificationForm.get('phoneNumber')?.errors?.['required']) {
              <span>Phone number is required</span>
            } @if (verificationForm.get('phoneNumber')?.errors?.['pattern']) {
              <span>Please enter a valid 10-digit phone number</span>
            }
          </p>
        }
      </div>

      <!-- Verification Code Field -->
      <div class="form-container">
        <app-custom-input
          [label]="'Verification Code'"
          [showLabel]="true"
          [showAsteric]="true"
          [placeholder]="'Enter 6-digit code'"
          formControlName="code"
          type="text"
          [maxlength]="6"
          (valueChange)="onCodeInput($event)"
        ></app-custom-input>
        @if (verificationForm.get('code')?.invalid && verificationForm.get('code')?.touched) {
          <p class="text-error text-xs mt-2 font-normal">
            @if (verificationForm.get('code')?.errors?.['required']) {
              <span>Verification code is required</span>
            } @if (verificationForm.get('code')?.errors?.['pattern']) {
              <span>Please enter a valid 6-digit code</span>
            }
          </p>
        }
      </div>

      <!-- Authenticate Button -->
      <div class="pt-4">
        <app-primary-button
          [text]="'Authenticate'"
          [isLoading]="isLoading"
          [isDisabled]="!verificationForm.valid || isLoading"
          (onClickEvent)="onSubmit()"
        ></app-primary-button>
      </div>
    </form>
  </div>
</main>
